/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const ModalBounty = (props: any) => {
  const { buttonLabel, className, modalTitle } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  return (
    <>
      <Button onClick={toggle}>{buttonLabel}</Button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
        <ModalBody>
          <p>Information:</p>
          <p>
            The game consists of a battle between the players, each person will
            receive a number that will equal his life (Roll) so you need to kill
            your opponents number on the dice. The roll is a hit on the opposite
            user, you can not kill your own number. We will have two stages in
            the game, the first stage will have a maximum of 99 players and a
            prize of 0.40 $ per kill (this can be modified). The second stage
            has a prize of 0.35 $ (this can be modified), in this stage it will
            be the union of the new registrations (so the player can register in
            this stage, but cannot was registered in the first stage) with those
            who do not have kills in the first stage and is dead (players will
            come automatically, without registration). There will be a
            registration time and there will be a duration of the game (15
            minutes in the first stage and 15 minutes in the second stage). The
            prize will be for the survivors of each stage (base * 10) and also
            for the number of hit to opponents (base * 35). The first 20 biggest
            killers of the week go to the MegaBounty every Friday, it has only
            one stage and prize 1.50$ per kill. The prizes can be distributed in
            several currencies such as: BTC, ETH, LTC, DOGE, XLM, USDT, TRX,
            XRP.
          </p>
          <p>Rules:</p>
          <ul>
            <li>
              Verified accounts only (the{' '}
              <a
                href="https://www.bitsler.com/en/settings/verification"
                target="_blank"
                rel="noopener noreferrer"
              >
                Account Verification
              </a>{' '}
              must be over)
            </li>
            <li>
              Players that &quot;hide their username from the bet lists&quot;
              cannot participate.
            </li>
            <li>
              Any bet amount below the minimum of basebet (depends on the game,
              will be at the top of the site) will not be able to kill.
            </li>
            <li>The maximum chance is 90% (Payout 1.1x).</li>
            <li>The bet result doesnt need to be a win itself.</li>
            <li>Only Dice bets are allowed.</li>
            <li>Bets before the game starts cannot be used.</li>
            <li>Bets after the game will not be valid.</li>
            <li>
              Base bet must be equal to or greater than those declared on the
              site for your bet to be valid.
            </li>
            <li>Bets from other players cannot be used.</li>
            <li>
              You will not be able to register for a step if it is already
              started.
            </li>
            <li>You will not be able to kill after you are dead.</li>
            <li>You cannot kill yourself.</li>
            <li>You cannot send rolls that are not on the list.</li>
            <li>You cannot hit a number that is already dead.</li>
            <li>You cannot register in two steps, only in one.</li>
            <li>
              Getting an edge against the other members is forbidden (taking
              advantage of any bug, using more than one account in order to
              abuse promotions, etc).
            </li>
          </ul>
        </ModalBody>
        <ModalFooter />
      </Modal>
    </>
  );
};

export default ModalBounty;
